<template>
  <div class="ibox">
      <div class="ibox-content ibox-content-padding-xs-slim">

        <form role="form">

            <div class="panel-group panel-group-stepper" id="create-job" role="tablist" aria-multiselectable="true" v-collapse-stepper>
              <div class="panel">
                <div class="panel-heading" role="tab" id="stepOne">
                  <h4 class="panel-title">
                    <a role="button" data-toggle="collapse" data-parent="#create-job" href="#job-details" aria-expanded="true" aria-controls="job-details">
                      <span class="stepper-number stepper-active" :class="{ 'stepper-error': errors.any() }">1</span> Job Details
                    </a>
                  </h4>
                </div>
                <div id="job-details" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="stepOne">
                  <div class="panel-body">

                    <div class="row row-clear-sm-6" v-if="$user.isAdminOrCoordinator">
											<div class="col-sm-6">
												<div class="form-group-outer">
													<div class="form-group float-label-control" :class="{ 'has-error': errors.has('user_id') }">
                            <label for="" class="select-label">User</label>

                            <selectize
                              :options="userOptions"
                              :fetch-results="fetchUserResults"
                              v-model="user"
                              name="user_id"
                              v-validate="{ required: $user.isAdminOrCoordinator }">
                            </selectize>
                          </div>
												</div><!-- /.form-group-outer -->
											</div>
											<div class="col-sm-6">
												<div class="form-group-outer">
													<div class="form-group float-label-control">
														<label for="" class="select-label">Coordinator</label>

                            <selectize
                              :options="coordinatorOptions"
                              :fetch-results="fetchCoordinatorResults"
                              v-model="coordinator"
                              name="coordinator_id">
                            </selectize>
													</div>
												</div><!-- /.form-group-outer -->
											</div>
										</div><!-- /.row -->

                    <h3>Date Range</h3>

                    <div class="margin-20"></div>

                    <div class="row row-clear-sm-6">
                      <div class="col-sm-6">
                        <div class="form-group-outer">
                          <div class="form-group float-label-control">
                            <label for="">Start Date</label>
                            <date-range name="start_date" v-model="startAt" :single-date-picker="true" opens="right" v-float-label></date-range>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group-outer">
                          <div class="form-group float-label-control">
                            <label for="">End Date</label>
                            <date-range v-model="endAt" name="end_date" :single-date-picker="true" opens="right" v-float-label></date-range>
                          </div>
                        </div>
                      </div>
                    </div>

                    <h3>What do you need transported?</h3>

                    <div class="margin-20"></div>

                    <div class="row row-clear-sm-6">
                      <div class="col-sm-6">
                        <div class="form-group-outer">
                          <div class="form-group float-label-control">
                            <label for="">Quantity (t)</label>
                            <input type="number" class="form-control" placeholder="Quantity (t)" v-model="quantity" min="0" v-float-label>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group-outer">
                          <div class="form-group float-label-control" :class="{ 'has-error': errors.has('commodity') }">
                            <label for="" class="select-label">Commodity</label>
                            <selectize
                              :options="commodityOptions"
                              v-model="commodity"
                              name="commodity"
                              v-validate="{ required: $user.isAdminOrCoordinator }">
                            </selectize>
                          </div>
                        </div>
                      </div>
                    </div>

                    <h3>Do you have additional reference details for this job?</h3>

                    <div class="margin-20"></div>

                    <div class="row row-clear-sm-6">
                      <div class="col-sm-6">
                        <div class="form-group-outer">
                          <div class="form-group float-label-control">
                            <label for="">Order Reference</label>
                            <input type="text" class="form-control" placeholder="Order Reference" name="order_reference" v-model="orderReference" v-float-label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row row-clear-sm-6">
                      <div class="col-sm-6">
                        <div class="form-group-outer">
                          <div class="form-group float-label-control">
                            <label for="">Pickup Reference</label>
                            <input type="text" class="form-control" placeholder="Pickup Reference" name="pickup_reference" v-model="pickupReference" v-float-label>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group-outer">
                          <div class="form-group float-label-control">
                            <label for="">Delivery Reference</label>
                            <input type="text" class="form-control" placeholder="Delivery Reference" name="job_reference" v-model="deliveryReference" v-float-label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="text-right">
                      <a
                        class="btn btn-primary"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#create-job"
                        aria-controls="job-details"
                        aria-expanded="true"
                        data-target="#location-details">
                        Next
                      </a>
                    </div>

                  </div>
                </div>
              </div>
              <div class="panel">
                <div class="panel-heading" role="tab" id="stepTwo">
                  <h4 class="panel-title">
                    <a class="collapsed" role="button" data-toggle="collapse" data-parent="#create-job" href="#location-details" aria-expanded="false" aria-controls="location-details">
                      <span class="stepper-number">2</span> Location Details
                    </a>
                  </h4>
                </div>
                <div id="location-details" class="panel-collapse collapse" role="tabpanel" aria-labelledby="stepTwo">
                  <div class="panel-body">

                    <div class="row">
                      <div class="col-md-9 col-lg-6">
                        <div class="form-group-outer">
                          <div class="form-group float-label-control">
                            <label for="" class="select-label">Location From</label>
                            <selectize
                              :options="locationOptionsFrom"
                              :fetch-results="fetchLocationResults('from')"
                              name="location_from"
                              v-model="locationFrom">
                            </selectize>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3 col-lg-6">
                        <a href="#drawer-location-add" data-toggle="drawer" aria-foldedopen="false" aria-controls="drawer-location-add"
                          class="btn btn-sm btn-success btn-new-location" @click="handleAddFromLocation">
                          <i class="fa fa-plus"></i> New
                        </a>
                      </div>
                    </div>

                    <div class="row" v-if="haveLocationFrom">
                      <div class="col-md-9 col-lg-6">
                        <div class="card card-location-overview">
                          <p>
                            <strong>{{ locationFromDecorated.name }}</strong>

                            <template v-if="locationFromDecorated.address"> - {{ locationFromDecorated.address }}</template>
                          </p>
                          <p>
                            <strong v-if="locationFromDecorated.contact_name">{{ locationFromDecorated.contact_name }}</strong>
                            <template v-if="locationFromDecorated.contact_phone"> - {{ locationFromDecorated.contact_phone }}</template>
                          </p>

                          <a
                            href="#drawer-location-add"
                            data-toggle="drawer"
                            aria-foldedopen="false"
                            aria-controls="drawer-location-add"
                            class="btn btn-xs btn-info btn-edit-location"
                            @click="handleEditFromLocation">
                            <i class="fa fa-pencil"></i> Edit
                          </a>
                        </div>
                      </div>
                    </div>

                    <div class="margin-20"></div>

                    <div class="row">
                      <div class="col-md-9 col-lg-6">
                        <div class="form-group-outer">
                          <div class="form-group float-label-control">
                            <label for="" class="select-label">Location To</label>
                            <selectize
                              :options="locationOptionsTo"
                              :fetch-results="fetchLocationResults('to')"
                              name="location_to"
                              v-model="locationTo">
                            </selectize>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3 col-lg-6">
                        <a href="#drawer-location-add" data-toggle="drawer" aria-foldedopen="false" aria-controls="drawer-location-add"
                          class="btn btn-sm btn-success btn-new-location" @click="handleAddToLocation">
                          <i class="fa fa-plus"></i> New
                        </a>
                      </div>
                    </div>

                    <div class="row" v-if="haveLocationTo">
                      <div class="col-md-9 col-lg-6">
                        <div class="card card-location-overview">
                          <p>
                            <strong>{{ locationToDecorated.name }}</strong>

                            <template v-if="locationToDecorated.address"> - {{ locationToDecorated.address }}</template>
                          </p>
                          <p>
                            <strong v-if="locationToDecorated.contact_name">{{ locationToDecorated.contact_name }}</strong>
                            <template v-if="locationToDecorated.contact_phone"> - {{ locationToDecorated.contact_phone }}</template>
                          </p>

                          <a
                            href="#drawer-location-add"
                            data-toggle="drawer"
                            aria-foldedopen="false"
                            aria-controls="drawer-location-add"
                            class="btn btn-xs btn-info btn-edit-location"
                            @click="handleEditToLocation">
                            <i class="fa fa-pencil"></i> Edit
                          </a>
                        </div>
                      </div>
                    </div>

                    <div class="margin-20"></div>

                    <div class="text-right">
                      <a
                        class="btn btn-info"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#create-job"
                        aria-controls="location-details"
                        aria-expanded="true"
                        data-target="#job-details">
                        Back
                      </a>

                      <a
                        class="btn btn-primary"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#create-job"
                        aria-controls="location-details"
                        aria-expanded="true"
                        data-target="#rate-and-job-notes">
                        Next
                      </a>
                    </div>

                  </div>
                </div>
              </div>
              <div class="panel">
                <div class="panel-heading" role="tab" id="stepThree">
                  <h4 class="panel-title">
                    <a class="collapsed" role="button" data-toggle="collapse" data-parent="#create-job" href="#rate-and-job-notes" aria-expanded="false" aria-controls="rate-and-job-notes">
                      <span class="stepper-number">3</span> Rate and Job Notes
                    </a>
                  </h4>
                </div>
                <div id="rate-and-job-notes" class="panel-collapse collapse" role="tabpanel" aria-labelledby="stepThree">
                  <div class="panel-body">

                    <h3>Rate</h3>
                    <p class="m-b-lg">How much would you like to pay per tonne for your transport. This price is subject to change during the job approval process.</p>

                    <div class="row">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="" class="control-label">Rate</label>
                          <div class="input-group">
                            <span class="input-group-addon">$</span>
                            <input type="number" class="form-control" placeholder="0.00" step="0.01" min="0" v-model="rate">
                            <span class="input-group-addon">/ tonne</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="checkbox checkbox-primary m-t-lg">
                          <input id="check-price-request" class="styled" type="checkbox" v-model="requestPrice">
                          <label for="check-price-request">
                            Request Price
                          </label>
                        </div>
                      </div>
                    </div>

                    <div class="row" v-if="$user.isAdmin">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <div class="checkbox checkbox-primary m-t-lg">
                            <input id="check-job-public" class="styled" type="checkbox" v-model="publicJob" />
                            <label for="check-job-public">
                              This job is available on the jobs board
                            </label>
                          </div>
                        </div>
                      </div>
                    </div><!-- /.row -->

                    <div class="margin-20"></div>

                    <h3>Job Notes</h3>
                    <p class="m-b-lg">Let us know of any specific requirements you have.</p>

                    <div class="form-group-outer">
                      <div class="form-group float-label-control form-group">
                        <label for="">Notes</label>
                        <textarea class="form-control" placeholder="Notes" style="resize: none" rows="5" v-model="notes" v-float-label></textarea>
                      </div>
                    </div>

                    <div v-if="$user.isClientOrCarrier">
                      <h3>Job Notifications</h3>
                      <p class="m-b-lg">What notifications do you want to receive for this job.</p>

                      <div class="form-group m-b-lg">
                        <div class="checkbox checkbox-primary">
                          <input id="check-notify-email" class="styled" type="checkbox" v-model="notifyJobStatus" />
                          <label for="check-notify-email">
                            Notify me of job status updates
                          </label>
                        </div>
                        <div class="checkbox checkbox-primary">
                          <input id="check-notify-email-delivery" class="styled" type="checkbox" v-model="notifyLoadDeliveries" />
                          <label for="check-notify-email-delivery">
                            Notify me of load deliveries
                          </label>
                        </div>
                      </div>
                    </div>

                    <div class="text-right">
                      <a
                        class="btn btn-info"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#create-job"
                        aria-controls="rate-and-job-notes"
                        aria-expanded="true"
                        data-target="#location-details">
                        Back
                      </a>

                      <ladda-button :on-click="handleSubmitJob" type="success" v-if="creatingNewJob">
                        Submit Job
                      </ladda-button>
                      <ladda-button :on-click="handleSaveJob" type="success" v-else>
                        Save Job
                      </ladda-button>
                    </div>

                  </div>
                </div>
              </div>
            </div>

          </form>
      </div>

      <location-drawer
        v-if="addingOrEditingLocation"
        :existing-location="locationBeingEdited"
        :done="locationDoneCallback"
        :closed="locationDrawerClosed">
      </location-drawer>
    </div>
</template>

<script>
  import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
  import { DateRange, Selectize, LaddaButton } from 'components/forms'
  import { SET_JOB_ATTRIBUTE, RESET_JOB, ADD_LOCATION, ADD_USERS } from 'vx/mutations'
  import { cloneDeep, upperFirst, trim, map, pick } from 'lodash'
  import { Roles } from 'utils/user'
  import { notify } from 'utils'
  import LocationDecorator from 'decorators/location'
  import LocationDrawer from './LocationDrawer'
  import stateMapper from 'mixins/jobs/state-mapper'

  export default {
    mixins: [stateMapper],

    components: {
      DateRange,
      Selectize,
      LaddaButton,
      LocationDrawer
    },

    data () {
      return {
        users: [],
        coordinators: [],
        addingOrEditingLocation: false,
        locationBeingEdited: {},
        locationDoneCallback: null,
        locationOptionsFrom: [],
        locationsFrom: [],
        locationOptionsTo: [],
        locationsTo: []
      }
    },

    created () {
      this[RESET_JOB]()

      this.getCommodities()
      this.getLocationsList().then(this.setLocationOptions)

      this.setupJobDefaultsFromUser()

      if (this.$user.isAdminOrCoordinator) {
        this.getUsers({ master: true, active: true }).then(response => {
          this.users = response.data.data

          if (this.job && this.job.user) {
            this.users.push(this.job.user)
          }
        })

        this.getUsers({ master: true, roles: [Roles.COORDINATOR], active: true }).then(response => {
          this.coordinators = response.data.data
        })
      }

      this.attemptToLoadExistingJob()
    },

    computed: {
      ...mapGetters('commodity', ['commodityOptions']),
      ...mapState('commodity', ['commodities']),
      ...mapGetters('location', ['locationOptions', 'locationsDecorated']),
      ...mapState('location', ['locations', 'locationsList']),
      ...mapGetters('job', ['jobPayload']),
      ...mapState('job', ['job']),

      /**
       * Determine if we are creating a new job or editing an existing.
       *
       * @return boolean
       */
      creatingNewJob () {
        return this.$route.name === 'jobs.create'
      },

      /**
       * Determine if we are editing an existing job.
       *
       * @return boolean
       */
      editingExistingJob () {
        return this.$route.name === 'jobs.edit'
      },

      /**
       * The decorated location from.
       *
       * @return array
       */
      locationFromDecorated () {
        return new LocationDecorator(this.job.location_from)
      },

      /**
       * The decorated location to.
       *
       * @return object
       */
      locationToDecorated () {
        return new LocationDecorator(this.job.location_to)
      },

      /**
       * Determine if we have a location from.
       *
       * @return boolean
       */
      haveLocationFrom () {
        return this.locationFrom !== null
      },

      /**
       * Determine if we have a location to.
       *
       * @return boolean
       */
      haveLocationTo () {
        return this.locationTo !== null
      },

      userOptions () {
        return map(this.users, user => ({ id: user.id, text: user.profile.company_name }))
      },

      coordinatorOptions () {
        return map(this.coordinators, coordinator => ({ id: coordinator.id, text: `${coordinator.profile.name} ${coordinator.profile.surname}` }))
      }
    },

    watch: {
      user (val) {
        this.getLocations({ user_id: val, public: true }).then(this.setLocationOptions)
      }
    },

    methods: {
      ...mapActions('commodity', ['getCommodities']),
      ...mapActions('location', ['getLocations', 'getLocationsList', 'getLocation']),
      ...mapActions('user', ['getUsers']),
      ...mapActions('job', ['storeJob', 'getJob', 'updateJob']),
      ...mapMutations('job', [SET_JOB_ATTRIBUTE, RESET_JOB]),
      ...mapMutations('location', [ADD_LOCATION]),
      ...mapMutations('user', [ADD_USERS]),

      /**
       * When admin types in the user select box we need to fetch more users
       * from the api since the users are paginated.
       */
      fetchUserResults (name, callback) {
        return this.getUsers({ name, master: true, active: true }).then(response => {
          this.users = response.data.data
          callback(this.userOptions)
        })
      },

      /**
       * When User types in the coordinator select box we need to fetch more coordinators
       * from the api since the coordinators are paginated.
       */
      fetchCoordinatorResults (name, callback) {
        return this.getUsers({ name, master: true, roles: [Roles.COORDINATOR], active: true }).then(response => {
          this.coordinators = response.data.data
          callback(this.coordinatorOptions)
        })
      },

      /**
       * If we are editing an existing job attempt to load it.
       *
       * @return void
       */
      attemptToLoadExistingJob () {
        if (this.editingExistingJob) {
          const jobNotFound = (error) => {
            if (error.response && error.response.statusCode === 404) {
              notify.error('This job could be not found.')
            } else {
              notify.error('You do not have permission to edit this job.')
            }

            this.$router.push({ name: 'jobs.index' })
          }

          const checkIfUserCanEdit = (response) => {
            if (this.job.status === 'completed') {
              throw new Error('Unable to edit a job that is completed.')
            } else if (this.$user.isClientOrCarrier && this.job.status !== 'pending') {
              throw new Error('Client is unable a job that is no longer pending.')
            } else {
              return response
            }
          }

          return this.getJob(this.$route.params.id)
            .then(checkIfUserCanEdit)
            .then(this.setLocationOptions)
            .then(this.addExistingUser)
            .catch(jobNotFound)
        }

        return Promise.resolve()
      },

      addExistingUser (response) {
        if (this.job.user) {
          this[ADD_USERS]([this.job.user])
          this.users.push(this.job.user)
        }

        return response
      },

      /**
       * Setup some job defaults from the authenticated user.
       *
       * @return void
       */
      setupJobDefaultsFromUser () {
        if (this.$user.isClientOrCarrier) {
          this.notifyJobStatus = this.$user.profile.notify_job_status
          this.notifyLoadDeliveries = this.$user.profile.notify_load_deliveries
        }
      },

      /**
       * Fetch location results. Because we can't rely on Vuex state as it will
       * change both of the dropdowns we need to have separate local state for
       * each of the dropdowns. The "which" variable identifies either the to
       * or from location. When we search in either we will populate the
       * desired local state object with the selectable locations from
       * the store.
       *
       * @param string which
       *
       * @return Function
       */
      fetchLocationResults (which) {
        return (keywords, callback) => {
          this.getLocations({ keywords, user_id: this.user, public: true }).then
          this.getLocationsList({ keywords, user_id: this.user }).then(() => {
            callback(this.setLocations(which))
          })
        }
      },

      /**
       * Set the initial location options.
       *
       * @return void
       */
      setLocationOptions () {
        this.setLocations('from')
        this.setLocations('to')
      },

      setLocations (type) {
        type = upperFirst(type)
        this[`locationOptions${type}`] = cloneDeep(this.locationOptions)
        this[`locations${type}`] = cloneDeep(this.locationsList)

        // add existing location back to option list
        const location = this.job[`location_${type.toLowerCase()}`]

        if (location) {
          this[`locationOptions${type}`].push({
            id: location.id,
            text: trim(`${location.name} ${location.suburb}`)
          })
          this[`locations${type}`].push(location)
        }
      },

      /**
       * When edit to location is clicked set the location being edited, set
       * the done callback when the save/add button is clicked, and toggle
       * the adding/editing location to true to show the drawer.
       *
       * @return void
       */
      handleEditToLocation () {
        this.locationBeingEdited = cloneDeep(this.job.location_to)

        this.locationDoneCallback = this.setToLocation

        this.addingOrEditingLocation = true
      },

      /**
       * When edit from location is clicked set the location being edited, set
       * the done callback when the save/add button is clicked, and toggle
       * the adding/editing location to true to show the drawer.
       *
       * @return void
       */
      handleEditFromLocation () {
        this.locationBeingEdited = cloneDeep(this.job.location_from)

        this.locationDoneCallback = this.setFromLocation

        this.addingOrEditingLocation = true
      },

      /**
       * When add new to location is clicked reset the location being edited,
       * set the done callback when the save/add button is clicked, and toggle
       * the adding/editing location to true to show the drawer.
       *
       * @return void
       */
      handleAddToLocation () {
        this.locationBeingEdited = {}

        this.locationDoneCallback = this.setToLocation

        this.addingOrEditingLocation = true
      },

      /**
       * When add new from location is clicked reset the location being edited,
       * set the done callback when the save/add button is clicked, and toggle
       * the adding/editing location to true to show the drawer.
       *
       * @return void
       */
      handleAddFromLocation () {
        this.locationBeingEdited = {}

        this.locationDoneCallback = this.setFromLocation

        this.addingOrEditingLocation = true
      },

      /**
       * Set the from location for callbacks.
       *
       * @param object location
       *
       * @return void
       */
      setFromLocation (location) {
        this.locationFrom = location

        this.setLocations('from')
      },

      /**
       * Set the to location for callbacks.
       *
       * @param object location
       *
       * @return void
       */
      setToLocation (location) {
        this.locationTo = location

        this.setLocations('to')
      },

      /**
       * When location drawer is closed we hide the component.
       *
       * @return {[type]}
       */
      locationDrawerClosed () {
        this.addingOrEditingLocation = false
      },

      /**
       * Redirect to show job page.
       *
       * @param object job
       *
       * @return void
       */
      redirectToShowJob (job) {
        if (this.$user.isAdminOrCoordinator) {
          this.$router.push({ name: 'jobs.requests' })
        } else {
          this.$router.push({ name: 'jobs.show', params: { id: job.id } })
        }
      },

      /**
       * Handle submitting a new job.
       *
       * @return Promise
       */
      handleSubmitJob () {
        const reportMissingUserError = () => {
          notify.error('There was no selected user or the user is invalid.')
        }

        const jobWasCreated = (job) => {
          notify.success('The job request has been placed.')

          return job
        }

        const storeJob = () => {
          return this.storeJob(this.jobPayload).then(response => {
            return response.data
          })
        }

        return this.validateAll()
          .then(storeJob)
          .then(jobWasCreated)
          .then(this.redirectToShowJob)
          .catch(reportMissingUserError)
      },

      /**
       * Handle the saving of an existing job.
       *
       * @return Promise
       */
      handleSaveJob () {
        const jobWasSaved = (job) => {
          notify.success('The job has been saved.')

          return job
        }

        const saveJob = () => {
          let payload = pick(this.jobPayload, [
            'user_id',
            'coordinator_id',
            'start_at',
            'end_at',
            'quantity',
            'order_reference',
            'delivery_reference',
            'pickup_reference',
            'location_from_id',
            'location_to_id',
            'rate',
            'request_price',
            'public',
            'notes',
            'commodity_id'
          ])

          return this.updateJob({ id: this.job.id, payload: payload }).then(response => response.data)
        }

        return this.validateAll()
          .then(saveJob)
          .then(jobWasSaved)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Form.vue?55040c00